/**
 * ImpersonationBanner - v1-Paritaet Admin-Impersonation
 *
 * Sichtbar solange eine Admin-Impersonation-Session aktiv ist (Backup-Keys
 * in sessionStorage vorhanden, siehe services/impersonation.ts). Struktur
 * analog zu DemoBanner.tsx.
 */
import { useTranslation } from "react-i18next"
import { useUserStore } from "../stores/userStore"
import { isImpersonating, restoreAdminSession } from "../services/impersonation"

export function ImpersonationBanner() {
  const { t } = useTranslation("adminUsers")
  const targetEmail = useUserStore((s) => s.user?.email) ?? ""

  if (!isImpersonating()) return null

  function handleReturn() {
    restoreAdminSession()
    window.location.assign("/admin/users")
  }

  return (
    <div
      data-testid="impersonation-banner"
      role="status"
      aria-label={t("banner.ariaLabel")}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "8px 16px",
        background: "var(--c-warning-bg, color-mix(in srgb, orange 12%, transparent))",
        borderBottom: "1px solid var(--c-warning-border, color-mix(in srgb, orange 25%, transparent))",
        fontSize: 13,
        color: "var(--text)",
        flexWrap: "wrap",
      }}
    >
      <span style={{ flex: 1, minWidth: 200 }}>{t("banner.message", { email: targetEmail })}</span>
      <button
        type="button"
        className="btn btn-ghost"
        style={{ fontSize: 12, padding: "4px 12px" }}
        onClick={handleReturn}
        data-testid="impersonation-banner-return"
      >
        {t("banner.returnButton")}
      </button>
    </div>
  )
}
